import { useQuery } from "react-query";
import http from "infra/http";

function useTipoVinculoPessoa() {
  return useQuery(["/v1/tipo-vinculo-pessoa"], async () => {
    const { data } = await http.get<{ id: string; nome: string }[]>(
      "/v1/tipo-vinculo-pessoa"
    );

    return data;
  });
}

export default useTipoVinculoPessoa;
